import React from 'react';
import { motion } from 'framer-motion';
import { IconWrapper } from '../common/IconWrapper';
import {
  HiBuildingOffice2,
  HiPhone,
  HiEnvelope,
  HiGlobeAlt
} from 'react-icons/hi2';

interface Office {
  city: string;
  address: string;
  phone: string;
  email: string;
  timezone: string;
}

const offices: Office[] = [
  {
    city: 'Indore',
    address: ' Kohinoor Tower, 218, Jawahar Marg, Opposite HDFC Bank, North Rajmohalla, Raj Mohalla, Indore, Madhya Pradesh 452002, India',
    phone: '+91 76490 99000',
    email: 'info@firstlogic.in',
    timezone: 'IST (UTC+5:30)'
  }
];

export const OfficeLocations: React.FC = () => {
  return (
    <div className="grid grid-cols-1 gap-8">
      {offices.map((office, index) => (
        <motion.div
          key={office.city}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.1 }}
          className="bg-white dark:bg-gray-800 rounded-3xl p-8 shadow-xl h-full flex flex-col justify-between border border-gray-100 dark:border-slate-700/50"
        >
          <div>
            <div className="flex items-center mb-4">
              <IconWrapper icon={HiBuildingOffice2} className="w-6 h-6 text-primary-light dark:text-primary-dark" />
            </div>
            <h3 className="text-2xl font-semibold mb-3">{office.city}</h3>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-6">{office.address}</p>
          </div>
          <div className="space-y-4 text-gray-600 dark:text-gray-400">
            <div className="flex items-center">
              <IconWrapper icon={HiPhone} className="w-5 h-5 mr-3" />
              <a href={`tel:${office.phone}`} className="hover:text-primary-light dark:hover:text-primary-dark font-medium">
                {office.phone}
              </a>
            </div>
            <div className="flex items-center">
              <IconWrapper icon={HiEnvelope} className="w-5 h-5 mr-3" />
              <a href={`mailto:${office.email}`} className="hover:text-primary-light dark:hover:text-primary-dark font-medium">
                {office.email}
              </a>
            </div>
            <div className="flex items-center">
              <IconWrapper icon={HiGlobeAlt} className="w-5 h-5 mr-3" />
              <span>{office.timezone}</span>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};